import {MdEmail, MdKeyboardArrowDown, MdOutlineTimer, MdSend} from "react-icons/md";
import {useEffect, useMemo, useRef, useState} from "react";
import axios from "axios";
import {useUserAuth} from "../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {FaEye} from "react-icons/fa";
// import {FaAndroid, FaApple} from "react-icons/fa";
import {DiAndroid, DiApple} from "react-icons/di";
import {toast} from "react-toastify";

const Course = (props) => {
    const {bgBox, icon, title, desc, day, date, deviceAddress, productId, extra, data, fid} = props;

    const CROMPTON_FEEDBACK_URL = process.env.REACT_APP_CROMPTON_SENZE_FEEDBACK;
    // const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;
    const secretKey = "cromptonssecretkey";
    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);

    const [showStatusPopup, setShowStatusPopup] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [showCommentBox, setShowCommentBox] = useState(false);
    const [comment, setComment] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [viewData, setViewData] = useState(null);
    const [loadingViewData, setLoadingViewData] = useState(false);
    const [errorViewData, setErrorViewData] = useState(null);
    const [showViewData, setShowViewData] = useState(false);

    const [showFull, setShowFull] = useState(false);
    const hasImage = typeof icon === "string" && icon.startsWith("data:image");

    // Add this state at the top with your other states
    const [showEmailReplyBox, setShowEmailReplyBox] = useState(false);

    // Regex to extract parts
    const regex = /^(.*?)\s*->\s*(.*?)\s*\(V:(.*?)\)$/;
    //console.log(title);
    const match = title.match(regex);
    //console.log(match);

    let categoryRaw = "";
    let subCategory = "";
    let version = "";

    const [emailReply, setEmailReply] = useState("");
    const [isEmailSending, setIsEmailSending] = useState(false);

    const [isOpen, setIsOpen]                 = useState(false);
    const [emailList, setEmailList]           = useState([]);
    const [selectedEmails, setSelectedEmails] = useState([]);
    const [isLoading, setIsLoading]           = useState(false);
    const dropdownRef                         = useRef(null);

    // ─── Fetch Users from API ─────────────────────────────────────────────────

    const fetchEmails = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get((`${CROMPTON_FEEDBACK_URL}feedback/get/allBccUsers`),{
                headers:{
                    Authorization: decryptedValue
                }
            });
            const cleaned = response.data.map((u) => ({
                id:    u.id,
                name:  u.name,
                email: u.email,
            }));
            setEmailList(cleaned);
            sessionStorage.setItem("bccEmailList", JSON.stringify(cleaned));
        } catch (err) {
            console.error("Failed to fetch BCC users:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if(sessionStorage.getItem("bccEmailList") === null){
            fetchEmails();
        }else{
            setEmailList(JSON.parse(sessionStorage.getItem("bccEmailList")));
        }
    }, []);

    // ─── Close on outside click ───────────────────────────────────────────────
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // ─── Handlers ─────────────────────────────────────────────────────────────
    // ✅ After — storing emails
    const handleCheckbox = (email) => {
        setSelectedEmails((prev) =>
            prev.includes(email)
                ? prev.filter((e) => e !== email)
                : [...prev, email]
        );
    };
    const handleSelectAll = () => setSelectedEmails(emailList.map((u) => u.email));
    const handleClearAll  = () => setSelectedEmails([]);

    // ─── Display Label ────────────────────────────────────────────────────────
    const displayLabel = selectedEmails.length === 0
        ? "Select recipients..."
        : `${selectedEmails.length} recipient${selectedEmails.length > 1 ? "s" : ""} selected`;


    function updateComment(text) {
        // console.log(text);
        setComment(text)
    }

    // Send email to user (notification)
    const handleEmailUser = async (email) => {
        setIsEmailSending(true);
        const url = `${process.env.REACT_APP_CROMPTON_SENZE_FEEDBACK}feedback/reply/V2/toUser`;
        try {
            var formData = {
                "email": email,
                "comment": comment,
                "fid": fid,
                "bccEmail": selectedEmails
            }

            return axios({
                method: "post",
                url: url,
                data: formData,
                headers: {
                    Authorization: decryptedValue,
                },
            })
                .then((response) => {
                    // console.log(response);

                    toast.success("Email sent to customer!");
                    setComment(""); // ← ADD THIS to clear textarea

                })
                .catch((error) => {
                    // console.log(error);
                    toast.error("Failed to send email");
                });
        } catch (error) {
            // console.log(error);
            toast.error("Failed to send email");
        } finally {
            setIsEmailSending(false);
        }
    };

// Send reply email
    const handleSendEmailReply = async (email) => {
        setIsEmailSending(true);
        await handleEmailUser(email)

    };

    if (match) {
        categoryRaw = match[1].trim();
        subCategory = match[2].trim();
        version = match[3].trim();
    }

    // Split category to extract user
    let category = categoryRaw;
    let user = "";
    /*if (categoryRaw.includes(" - ")) {
        const parts = categoryRaw.split(" : ");
        category = parts[0].trim();   // e.g. "Mobile App"
        user = parts[1].trim();       // e.g. "rupanshu1506@gmail.com"
        console.log("Category: " + category);
        console.log("User: " + user);
    }*/
    if (categoryRaw.includes(" - ")) {
        const separator = " - ";
        const lastSeparatorIndex = categoryRaw.lastIndexOf(separator);

        category = categoryRaw.substring(0, lastSeparatorIndex).trim();
        user = categoryRaw.substring(lastSeparatorIndex + separator.length).trim();

        //console.log("Category: " + category);
        //console.log("User: " + user);
    }

    const invalidVersions = ["NA", "null", "", null, undefined];
    const isValidVersion = !invalidVersions.includes(version);

    // Decide platform only if version is valid
    let platform = "";
    if (isValidVersion) {
        if (version.includes("(")) {
            platform = "ios";
        } else {
            platform = "android";
        }
    }

    const handleStatusChange = (id, newStatus) => {
        setSelectedStatus(newStatus);
        setShowStatusPopup(false);

        if (newStatus.toUpperCase() === "OPEN") newStatus = 0;
        if (newStatus.toUpperCase() === "CLOSED") newStatus = 2;
        if (newStatus.toUpperCase() === "ONGOING") newStatus = 1;

        modifyFeedbackStatus(id, newStatus);
    };

    const handleCommentSave = () => {
        setShowCommentBox(false);
        modifyFeedbackStatusWithComments(data.id, data.status, comment);
    };

    function modifyFeedbackStatus(id, status) {
        var bodyFormData = {
            id: id,
            status: status,
        };

        return axios({
            method: "post",
            url: CROMPTON_ANALYTICS_URL + "v1/user/feedbacks/updateStatus",
            data: bodyFormData,
            headers: {
                Authorization: decryptedValue,
            },
        })
            .then((response) => {
                setErrorMessage("Feedback status updated.");
                window.location.reload();
            })
            .catch((error) => {
                setErrorMessage(error.response.data.message);
            });
    }

    function modifyFeedbackStatusWithComments(id, status, comments) {
        var bodyFormData = {
            id: id,
            status: status,
            comments: comments,
        };

        return axios({
            method: "post",
            url: CROMPTON_ANALYTICS_URL + "v1/user/feedbacks/updateComment",
            data: bodyFormData,
            headers: {
                Authorization: decryptedValue,
            },
        })
            .then((response) => {
                console.log(response)
                setErrorMessage("Feedback status updated with comments.");
                //window.location.reload();
            })
            .catch((error) => {
                console.log(error.response.data.message);
                setErrorMessage(error.response.data.message);
            });
    }

    const handleViewCommentAndTicket = async () => {
        const next = !showViewData;
        setShowViewData(next);

        setErrorViewData(null);
        if (next && !viewData) {
            setLoadingViewData(true);
            try {
                const response = await axios({
                    method: "get",
                    url: CROMPTON_ANALYTICS_URL + "v1/user/feedbacks/getById/" + data.id,
                    headers: {
                        Authorization: decryptedValue,
                    },
                });
                setViewData(response.data.feedbackAssignInfo || {
                    ticketNumber: "Not assigned",
                    comment: "No comment has been added yet.",
                });
            } catch (error) {
                setErrorViewData(error?.response?.data?.message || error.message || "Unable to load ticket details.");
            } finally {
                setLoadingViewData(false);
            }
        }
    };

    // This block runs only once and creates a fast lookup map.
    const deviceNameMap = useMemo(() => {
        const catalogString = sessionStorage.getItem("productCatalogArray");
        if (!catalogString) {
            console.warn("productCatalogArray not found in sessionStorage.");
            return new Map(); // Return an empty map if data doesn't exist
        }

        try {
            const productCatalog = JSON.parse(catalogString);
            // Create a Map where: key = deviceAddress, value = deviceName
            return new Map(
                productCatalog.map(item => [item.productId, item.product])
            );
        } catch (error) {
            console.error("Failed to parse productCatalogArray from sessionStorage:", error);
            return new Map(); // Return an empty map on parsing error
        }
    }, []); // The empty dependency array [] ensures this runs only once

    const getDeviceNameByAddress = (address) => {
        if (!address) {
            return ""; // Handle cases where address is null or undefined
        }
        // Use the map to find the name. Provide a fallback if not found.
        return "→ " + deviceNameMap.get(address) || "Unknown Device";
    };

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const createdAt = data?.createdTime ? new Date(data.createdTime) : null;
    const closedAt = data?.status === 2 && data?.lastModified ? new Date(data.lastModified) : new Date();
    const ageInDays = createdAt && !Number.isNaN(createdAt.getTime())
        ? Math.max(0, Math.ceil((closedAt.getTime() - createdAt.getTime()) / 86400000))
        : null;
    const ageColor = ageInDays === null
        ? "bg-gray-100 text-gray-600 dark:bg-white/10 dark:text-gray-300"
        : ageInDays <= 3
            ? "bg-green-100 text-green-700 dark:bg-green-500/20 dark:text-green-300"
            : ageInDays <= 10
                ? "bg-orange-100 text-orange-700 dark:bg-orange-500/20 dark:text-orange-300"
                : "bg-red-100 text-red-700 dark:bg-red-500/20 dark:text-red-300";

    //let productCatalog = JSON.parse(sessionStorage.getItem("productCatalogArray"))

    return (
        <div
            className={`flex w-full flex-col rounded-2xl border border-gray-100 bg-white p-6 shadow-lg shadow-gray-200/50 dark:border-white/10 dark:bg-navy-800 dark:shadow-none ${extra}`}
        >
            {/*  Header Section
            <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                 Title & Description

                <div className="flex flex-col gap-1">
                     User
                    <div className="text-base font-semibold text-gray-800 dark:text-white">
                        {user}
                    </div>

                     Category + SubCategory
                    <div className="text-sm text-gray-600 dark:text-gray-300">
                        {category} → {subCategory}
                    </div>

                     Device Name + Product Name
                    <div className="text-sm font-semibold text-gray-800 dark:text-gray-300">
                        {deviceAddress}  {getDeviceNameByAddress(productId)}
                    </div>

                    {isValidVersion && (
                        <div className="flex items-center gap-3 text-sm text-gray-500 dark:text-gray-400">
          <span className="px-2 py-0.5 rounded-lg bg-gray-100 dark:bg-navy-700 font-medium shadow-sm">
            V{version}
          </span>

                            {platform === "android" && (
                                <span className="flex items-center gap-1 text-green-600">
              <DiAndroid className="text-lg"/> Android
            </span>
                            )}
                            {platform === "ios" && (
                                <span className="flex items-center gap-1 text-gray-800">
              <DiApple className="text-lg"/> iOS
            </span>
                            )}
                        </div>
                    )}
                    <p className="mt-2 text-xl font-semibold text-gray-800 dark:text-gray-300 leading-relaxed">
                        {desc}
                    </p>
                </div>


                 Created/Modified
                <div className="mt-4 md:mt-0 text-right text-xs text-gray-500 dark:text-gray-400">
                    <p>Created: {day}</p>
                    <p>Last Modified: {date}</p>
                </div>
            </div>*/}

            <div className="flex flex-col gap-3">
                {/* Header Row: User + Version Badge */}
                <div className="flex items-center justify-between">
                    <div className="text-base font-semibold text-gray-800 dark:text-white">
                        {user}
                    </div>
                    {isValidVersion && (
                        <span className="px-2 py-0.5 rounded-lg bg-gray-100 dark:bg-navy-700 font-medium text-sm">
        V{version}
      </span>
                    )}
                </div>

                <div className="flex flex-wrap items-center gap-2 text-xs">
                    <span className="rounded-full bg-blue-50 px-3 py-1.5 font-medium text-[#004c86] dark:bg-blue-500/10 dark:text-blue-200">
                        Posted: {day || "Not available"}
                    </span>
                    <span className={`rounded-full px-3 py-1.5 font-bold ${ageColor}`}>
                        {ageInDays === null
                            ? "Age unavailable"
                            : data?.status === 2
                                ? `Resolved after ${ageInDays} day${ageInDays === 1 ? "" : "s"}`
                                : `Pending ${ageInDays} day${ageInDays === 1 ? "" : "s"}`}
                    </span>
                    {date && <span className="text-gray-500 dark:text-gray-400">Last updated: {date}</span>}
                </div>

                {/* Metadata Row: Category + Platform */}
                <div className="flex items-center justify-between text-sm">
    <span className="text-gray-600 dark:text-gray-300">
      {category} → {subCategory}
    </span>
                    {platform && (
                        <span className="flex items-center gap-1 text-gray-500 dark:text-gray-400">
        {platform === "android" && (
            <>
                <DiAndroid className="text-green-600"/> Android
            </>
        )}
                            {platform === "ios" && (
                                <>
                                    <DiApple className="text-gray-600"/> iOS
                                </>
                            )}
      </span>
                    )}
                </div>

                {/* Device Info */}
                <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    {deviceAddress} {getDeviceNameByAddress(productId)}
                </div>

                {/* Description */}
                <p className="mt-1 text-base text-gray-700 dark:text-gray-300 leading-relaxed">
                    {desc}
                </p>

            </div>


            {/* Divider */}
            <hr className="my-4 border-gray-200 dark:border-white/20"/>

            {/* IMAGE Section */}
            {hasImage && (
                <div
                    className="relative w-32 h-32 mb-4 rounded-xl overflow-hidden border border-gray-200 dark:border-gray-600">
                    <img
                        src={icon}
                        alt="Feedback"
                        className="w-full h-full object-contain bg-gray-50 dark:bg-navy-700"
                    />
                    <button
                        className="absolute top-2 right-2 flex items-center justify-center w-8 h-8 rounded-full
              backdrop-blur-sm bg-white/80 text-black border border-black shadow-md hover:bg-white transition z-10"
                        onClick={() => setShowFull(true)}
                        title="View Full Image"
                    >
                        <FaEye size={16} color="#004c86"/>
                    </button>
                </div>
            )}

            {/* Fullscreen Image Modal */}
            {showFull && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 p-4"
                    onClick={() => setShowFull(false)}
                >
                    <img
                        src={icon}
                        alt="Full Preview"
                        className="max-h-full max-w-full object-contain rounded-lg shadow-lg"
                    />
                </div>
            )}

            {/* Action Row */}
            <div className="flex flex-wrap gap-3 items-center justify-between">
                {/* Status Dropdown */}
                <select
                    id="statusSelect"
                    onChange={(e) => handleStatusChange(data.id, e.target.value)}
                    defaultValue=""
                    className="rounded-md border border-gray-300 bg-white px-3 py-1 text-sm font-medium text-gray-700 hover:cursor-pointer dark:bg-navy-700 dark:text-white dark:border-white/20"
                >
                    <option value="" disabled>
                        Update Status
                    </option>
                    {[
                        {label: "Open", value: 0},
                        {label: "Ongoing", value: 1},
                        {label: "Closed", value: 2},
                    ].map((status) => (
                        <option key={status.value} value={status.value}>
                            {status.label}
                        </option>
                    ))}
                </select>

                {/* Add Comment */}
                <button
                    onClick={() => setShowCommentBox(!showCommentBox)}
                    className="rounded-lg bg-[#004c86] px-4 py-1 text-sm font-semibold text-white shadow-sm hover:bg-[#00376d]"
                >
                    Add Comment
                </button>

                {/* Send Email Reply Button */}
                <button
                    onClick={() => setShowEmailReplyBox(!showEmailReplyBox)}
                    className="rounded-lg bg-[#004c86] px-4 py-1 text-sm font-semibold text-white shadow-sm hover:bg-[#00376d]"
                >
                    Send Email Reply
                </button>
            </div>

            {/* Comment Box */}
            {showCommentBox && (
                <div className="mt-3 flex flex-col gap-2 rounded-md border border-gray-200 p-3 dark:border-white/20">
          <textarea
              className="w-full rounded-md border px-2 py-1 text-sm dark:bg-navy-900 dark:text-white"
              rows="3"
              placeholder="Write your comment..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
          ></textarea>
                    <div className="flex gap-2 self-end">
                        <button
                            onClick={handleCommentSave}
                            className="rounded-md bg-[#004c86] px-3 py-1 text-sm text-white hover:bg-[#00376d]"
                        >
                            Save
                        </button>
                        <button
                            onClick={() => setShowCommentBox(false)}
                            className="rounded-md border border-gray-300 px-3 py-1 text-sm text-gray-600 hover:bg-gray-100 dark:border-white/30 dark:text-white dark:hover:bg-white/10"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            )}

            {/* Email Section - Only show if feedback came from email */}
            {isValidEmail(user) && (
                <div>
                    {showEmailReplyBox && (
                        <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
                            {/* User Email Display */}
                            <div className="flex items-center justify-between mb-4">
                                <div className="flex items-center gap-2">
                                    <MdEmail className="text-gray-500 text-lg"/>
                                    <div>
                                        <p className="text-xs text-gray-500 dark:text-gray-400">Customer Email</p>
                                        <p className="text-sm font-medium text-gray-800 dark:text-white">
                                            {user}
                                        </p>
                                    </div>
                                </div>
                                {/* ── Right — BCC Dropdown ──────────────────────────────────────── */}
                                <div className="relative" ref={dropdownRef}>

                                    {/* Label */}
                                    <p className="text-xs text-gray-500 dark:text-gray-400 mb-1 text-right">
                                        BCC Recipients
                                    </p>

                                    {/* Trigger Button */}
                                    <button
                                        onClick={() => setIsOpen((prev) => !prev)}
                                        className="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-gray-200 dark:border-navy-600 bg-white dark:bg-navy-800 text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-navy-700 transition-all duration-200 min-w-[170px] justify-between"
                                    >
                                        <span className="truncate max-w-[140px]">{displayLabel}</span>
                                        <MdKeyboardArrowDown
                                            className={`text-gray-500 text-lg flex-shrink-0 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
                                        />
                                    </button>

                                    {/* Dropdown Panel */}
                                    {isOpen && (
                                        <div className="absolute right-0 mt-1.5 w-72 bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 rounded-xl shadow-xl z-50 overflow-hidden">

                                            {/* Select All / Clear */}
                                            <div className="flex items-center justify-between px-4 py-2.5 border-b border-gray-100 dark:border-navy-700 bg-gray-50 dark:bg-navy-900">
              <span className="text-xs text-gray-500 dark:text-gray-400 font-medium">
                {selectedEmails.length} of {emailList.length} selected
              </span>
                                                <div className="flex gap-2 items-center">
                                                    <button
                                                        onClick={handleSelectAll}
                                                        className="text-xs text-[#004c86] dark:text-white font-semibold hover:underline bg-transparent border-none cursor-pointer"
                                                    >
                                                        All
                                                    </button>
                                                    <span className="text-gray-300 dark:text-gray-600">|</span>
                                                    <button
                                                        onClick={handleClearAll}
                                                        className="text-xs text-red-500 dark:text-red-400 font-semibold hover:underline bg-transparent border-none cursor-pointer"
                                                    >
                                                        Clear
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Loading */}
                                            {isLoading && (
                                                <div className="flex items-center justify-center gap-2 py-8 text-gray-400 dark:text-gray-500">
                                                    <div className="w-4 h-4 border-2 border-gray-200 dark:border-navy-600 border-t-indigo-500 rounded-full animate-spin" />
                                                    <span className="text-xs">Loading...</span>
                                                </div>
                                            )}

                                            {/* Email List */}
                                            {!isLoading && (
                                                <div className="max-h-52 overflow-y-auto">
                                                    {emailList.length === 0 ? (
                                                        <p className="text-xs text-gray-400 dark:text-gray-500 text-center py-8">
                                                            No recipients found.
                                                        </p>
                                                    ) : (
                                                        emailList.map((u) => (
                                                            <label
                                                                key={u.id}
                                                                className="flex items-center gap-3 px-4 py-2.5 cursor-pointer hover:bg-gray-50 dark:hover:bg-navy-700 transition-colors duration-150"
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedEmails.includes(u.email)}
                                                                    onChange={() => handleCheckbox(u.email)}
                                                                    className="w-4 h-4 rounded accent-indigo-600 cursor-pointer flex-shrink-0"
                                                                />
                                                                <div className="overflow-hidden">
                                                                    <p className="text-sm font-medium text-gray-700 dark:text-gray-200 truncate">
                                                                        {u.name}
                                                                    </p>
                                                                    <p className="text-xs text-gray-400 dark:text-gray-500 truncate">
                                                                        {u.email}
                                                                    </p>
                                                                </div>
                                                            </label>
                                                        ))
                                                    )}
                                                </div>
                                            )}

                                        </div>
                                    )}
                                </div>
                                {/* <button
                                onClick={() => handleEmailUser(user)}
                                disabled={isEmailSending}
                                className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white text-sm rounded-lg transition-colors"
                            >
                                {isEmailSending ? "Sending..." : "Send Email"}
                            </button>*/}
                            </div>

                            {/* Email Reply Section */}
                            <div className="space-y-3">
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                    Reply to Customer
                                </label>

                                <textarea
                                    value={comment}
                                    onChange={(e) => updateComment(e.target.value)}
                                    placeholder="Type your response to send to the customer..."
                                    rows={4}
                                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />

                                <div className="flex gap-2 justify-end">
                                    <button
                                        onClick={() => setComment("")}
                                        className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                                    >
                                        Clear
                                    </button>
                                    <button
                                        onClick={() => handleSendEmailReply(user)}
                                        disabled={!comment.trim()}
                                        className="px-4 py-2 bg-[#004c86] hover:bg-blue-700 disabled:bg-gray-400 text-white rounded-lg transition-colors flex items-center gap-2"
                                    >
                                        <>
                                            <MdSend/> Send Reply
                                        </>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

            )}

            {/* View Comment & Ticket */}
            <div className="mt-4">
                <button
                    onClick={handleViewCommentAndTicket}
                    className="text-sm font-medium text-[#004c86] hover:underline"
                >
                    {showViewData ? "Hide Comment & Ticket" : "View Comment & Ticket"}
                </button>

                {showViewData && (
                    <div className="mt-2 rounded-md bg-gray-50 p-3 text-sm shadow-sm dark:bg-navy-700 dark:text-white">
                        {loadingViewData && (
                            <p className="text-gray-500 dark:text-gray-300">Loading...</p>
                        )}
                        {errorViewData && (
                            <p className="text-red-500 dark:text-red-400">
                                Error: {errorViewData}
                            </p>
                        )}
                        {viewData && (
                            <>
                                <p className="font-medium">
                                    <strong>Ticket #:</strong> {viewData.ticketNumber}
                                </p>
                                <p className="mt-1">
                                    <strong>Comment:</strong> {viewData.comment}
                                </p>
                            </>
                        )}
                    </div>
                )}

                {/* Fullscreen Image Modal */}
                {showFull && (
                    <div
                        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 p-4"
                        onClick={() => setShowFull(false)}
                    >
                        <img
                            src={icon}
                            alt="Full Preview"
                            className="max-h-full max-w-full object-contain rounded-lg shadow-lg"
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Course;
